import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { type ParentFormConfigField } from '../model/parent-form-config.type';

export interface getParentFormConfigAPIResponse {
  studioId: string;
  formFields: Array<ParentFormConfigField>;
  isActive: boolean;
  entity: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface getParentFormConfigParams {
  formFields: Array<ParentFormConfigField>;
  isActive: boolean;
  entity: 'parent';
}

export const getParentFormConfigAPI = async () => {
  const response = await baseAPI.get<getParentFormConfigAPIResponse>(
    `custom-form-config/parent`,
  );
  return response.data;
};

export const useGetParentFormConfig = () => {
  return useQuery({
    queryKey: [KEYS.PARENT_FORM_CONFIG],
    queryFn: () => getParentFormConfigAPI(),
  });
};
